import Login from '../pages/Login'
import Account from '../pages/Account'
import NewUser from './workflows/newUser'
import SendMessage from './workflows/sendMessage'

// Route Definitions
const routeList = [
  { path: '/login', name: 'login', component: Login, alias: '/', meta: { requiresAuth: false } },
  { path: '/account', name: 'account', component: Account, meta: { requiresAuth: true } },
  NewUser,
  SendMessage,
  { path: '*', name: '404', redirect: { name: 'account' } }
]

export const landingPage = '/newUser'
export const mainPage = '/account'
export const loginPage = '/login'
export const routes = routeList
export default routeList



// WEBPACK FOOTER //
// ./src/router/routes.js